const workercode = () => {
    let interval = 0;
    let terminate = 0;
    let reconnectTrial = 0;
    let timer = 0;

    const TIMEOUT = 30000;
    const HB_SEND_INTERVAL = 10000;
    const WS_RECONNECT_INTERVAL = 3000;
    const MAX_RETRIES = 30;
    const FORWARD_INTERVAL=1000;

    function setTimer() {
        terminate = setTimeout(() => {
            /**
             * Close the ws connection 
             * if server does not respond in 
             * 30 seconds, pings won't be sent
             */
            clearInterval(interval);
            postMessage('reconnect');
        }, TIMEOUT);
    }

    function connect(heartbeatInterval) {
        interval = setInterval(() => {
            postMessage('Send heartbeat')
        }, heartbeatInterval);
        setTimer();
    }

    function forwardsTimer(subDetails) {
        timer = setInterval(() => {
            postMessage(`reduceSeconds_${subDetails}`)
        }, FORWARD_INTERVAL)
    }

    let startTime = 0;
    const STREAM_DURATION = 90; // use your actual duration

function swapforwardsTimer(subDetails) {
    clearInterval(timer);
    startTime = Date.now();
    timer = setInterval(() => {
        const elapsed =
            Math.floor((Date.now() - startTime) / 1000);

        const remaining =
            Math.max(STREAM_DURATION - elapsed, 0);

        postMessage(
            [`reduceSeconds_${subDetails}_${remaining}`, 'swap']
        );

        if (remaining <= 0) {
            clearInterval(timer);
        }

    }, FORWARD_INTERVAL);
}

    self.onmessage = function(e) {
        let stream;
        let type = "";
        if (Array.isArray(e.data)) {
            stream = e.data[0];
            type = e.data[1];
        } else {
            stream = e.data;
        }
        switch(stream) {
            case 'resetTimers':
                clearInterval(interval);
                clearTimeout(terminate);
                break;
            case 'reset':
                clearInterval(interval);
                clearTimeout(terminate);
                postMessage('terminate');
                break;
            case 'start':
                connect(HB_SEND_INTERVAL);
                break;
            case "resetTimeout":
                clearTimeout(terminate);                
                // reset reconnection count as ACK has been received
                reconnectTrial = 0;
                // set new timeout for last heartbeat ack
                setTimer();
                break;
            case 'reconnect':
                reconnectTrial++;
                // retry count is 30 for 90 seconds
                if (reconnectTrial <= MAX_RETRIES) {
                    connect(WS_RECONNECT_INTERVAL);
                } else {
                    postMessage('terminate')
                }
                break;
            case "resetFWDTimer":
                   clearInterval(timer);
                break;
            default:
                if (stream.split('_')[0].includes('QR')) {
                    if(type === 'swap') {
                        swapforwardsTimer(stream); //this is for swap panel stale rate issue(not for popout)
                    }else{
                        forwardsTimer(stream)
                    }
                }
                break;
        }
    }
};

let code = workercode.toString();
code = code.substring(code.indexOf("{")+1, code.lastIndexOf("}"));

const blob = new Blob([code], {type: "application/javascript"});
const worker_script = URL.createObjectURL(blob);

export { worker_script };